<div>
    <ngx-create-user-customer *ngIf="custid > 0" [fromprofilepage]="1"></ngx-create-user-customer>
    <ngx-create-user-airline  *ngIf="airid > 0" [fromprofilepage]="1"></ngx-create-user-airline>
</div>